module.exports = __webpack_public_path__ + "favicon.png?69f973bd875b6ebb6bb4f8416b8023db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = 736
// module chunks = 0